import { API_URL, CONSULTANT_API_URL } from '../../constants/config'
import { query } from '../utilities'

export const fetchIndividualEstimate = (
  opportunityId,
  estimateId,
  isConsultant,
  accessToken
) => {
  if (isConsultant) {
    return query(
      `${CONSULTANT_API_URL}/Email/${opportunityId}/quote/${estimateId}/oly`,
      {},
      accessToken
    )
  } else {
    return query(`${API_URL}/Email/${opportunityId}/quote/${estimateId}/oly`)
  }
}
